import Use from './src/main'

Use.install = function (Vue) {
    Vue.component(Use.name, Use)
}

export default Use